module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b3ec03f8b5153e8345374a8b4da6422.png";